import { Protocol } from "./_types";

export const LIB_PROTOCOL_KIWI_VINE_SCREEN_EVAL: Protocol = {
    id: "kiwi_vine_screen_eval",
    title: "Advanced Kiwi Vine Evaluation",
    description: "Vine Evaluation is performed to characterise the adaptability of cultivars and selections on the base of a full set of tree characteristics and includes all phenological stages and manipulation events. Characteristics such as growth, flowering and fruit set, diseases and pests and general adaptability are evaluated in detail. ",
    sampleType: "plant",

    chars: [
        //* PHENOLOGICAL PHASES
        "date_vine_bud_swell",
        "date_vine_bud_burst",
        "date_vine_full_bud_30",
        "date_vine_leaf_tips",
        "date_vine_cluster_open",
        "date_vine_leaf_visible",
        "date_vine_leaf_unfold",
        "date_vine_10_shoot",
        "date_vine_50_shoot",
        "date_vine_90_shoot",
        "date_vine_sepals",
        "date_vine_balloon",
        "date_vine_start_flower",
        "date_vine_10_flower",
        "date_vine_50_flower",
        "date_vine_full_bloom_60",
        "date_vine_flower_end",
        "date_vine_petal_end",
        "date_vine_frut_develop",
        "date_vine_frut_mature",
        "date_vine_seeds_colour",
        "date_vine_seeds_black",
        "date_vine_full_ripe",
        "date_vine_leaf_drop",
        "date_vine_leaf_drop_end",
        // TODO ADD CALCULATIONS WHERE NEEDED

        //* VINE MALE CHARS
        "date_male_bud_swell",
        "date_male_balloon",
        "date_male_bud_burst",
        "date_male_start_flower",
        "date_male_10_flower",
        "date_male_50_flower",
        "date_male_full_bloom",
        "date_male_petal_end",
        "vine_male_pollen_qual",
        "vine_male_pollen_quant",
        "vine_male_stamen_quant",
        "vine_male_pre_disease_stat",

        //* VINE BEARING
        "vine_pick_count",
        "vine_harv_ready_seed",

        //* VINE THINNING
        "vine_thin_technique",
        "date_vine_thin",
        "vine_thin_cycles",
        "vine_thin_application",
        "vine_thin_level",
        "vine_thin_stage",

        //* VINE PRUNING
        "vine_prune_technique",
        "date_vine_prune",
        "vine_prune_level",
        "vine_prune_cycles",
        "vine_prune_objective",
        "vine_prune_stage",

        //* VINE GIRDLING
        "vine_girdling_technique",
        "date_vine_girdling",
        "vine_girdling_objective",
        "vine_girdling_cycles",
        "vine_girdling_method",
        "vine_girdling_stage",

        //* VINE SPRAYING
        "vine_spray_content",
        "date_vine_spray",
        "vine_spray_stage",
        "vine_spray_cycles",

        //* VINE ASSISTED POLLINATION
        "vine_pollin_technique",
        "date_vine_assisted_pollin",
        "vine_assisted_pollin_stage",

        //* VINE ROOT-SPECIFIC CHARACTERISTICS
        "vine_root_depth",
        "vine_root_density",
        "vine_root_config",
        "vine_root_suckering",
        "vine_root_propagation_ease",
        "vine_root_in_vitro",
        "vine_root_compatibility",
        "vine_root_synchronisation",

        //* VINE ARCHITECTURE
        "vine_growth_habit",
        "vine_growth_potent_vigour",
        "vine_growth_canopy_dense",

        //* VINE LEAF CHARACTERISTICS
        "vine_leaf_colour",
        "vine_leaf_chroma",
        "vine_leaf_intensity",
        "vine_leaf_pubescence",

        //* VINE FLOWERING
        "vine_flower_even_budbreak",
        "vine_flower_repro_potent",
        "vine_flower_per_bud",
        "vine_flower_king",
        "vine_flower_triples",
        "vine_flower_quality",
        "vine_flower_dense",
        "vine_flower_distrib",
        "vine_flower_position",
        "vine_flower_rba",
        "vine_flower_rba_date",
        "vine_flower_rba_rate",

        //* VINE FLOWER TERMINATION AND DISORDERS
        "vine_flower_abnormal",
        "vine_abnormal_fruit_ratio",

        //* VINE PREHARVEST CROP MONITORING
        "vine_unform_ripe_harv",
        "vine_stalk_size",
        // "vine_seed_colour", // REMOVED SEEMS REDUNDANT AS A CHAR GIVEN THE PHENOLOGICAL CHARS

        //* VINE BEARING
        "vine_pollin_effi",

        //* VINE BEARING DISORDERS
        "vine_alt_bearing",
        "vine_preharv_drop",

        //* VINE PRODUCTIVITY CHARS
        "vine_fruit_set_potent",
        "vine_fruit_set_date",
        "vine_precociousness",
        // "vine_crop_load_potent", // WAS REMOVED FROM DOCUMENTATION (SO WE REMOVED IT FOR REVIEW)
        "vine_bear_potent_before",
        "vine_bear_potent_after",
        "vine_production_potent",

        //* VINE PREHARVEST PESTS
        "vine_preharv_pest_vine",
        "vine_preharv_pest_root",
        "vine_pre_pest_prev",
        "vine_pre_pest_sever",

        //* VINE PREHARVEST DISEASE
        "vine_pre_disease_stat",
        "vine_preharv_disease_vine",
        "vine_preharv_disease_root",
        "date_vine_preharv_disease",
        "vine_pre_disease_prev",
        "vine_pre_disease_sever",

        //* VINE PREHARVEST DEFECTS AND DISORDERS
        "vine_preharv_defect_ident",
        "vine_pre_defect_prev",
        "vine_pre_defect_sever",
        "vine_preharv_disorder_ident",
        "vine_pre_disorder_prev",
        "vine_pre_disorder_sever",

        //* REACTION TO PREHARVEST ABIOTIC STRESS FACTORS
        "vine_physical_dmg_ident",
        "date_vine_physical_dmg",
        "vine_physical_dmg_tolerance",
        "vine_abiotic_ident",
        "date_vine_abiotic_stress",
        "vine_abiotic_dmg_level",
        "vine_abiotic_stress_tol",
        "vine_soil_texture_pref",

        //* VINE PREHARVEST ADAPTABILITY INDEX
        "vine_dormant_release_eff",
        // "vine_flower_intense", // WAS REMOVED FROM DOCUMENTATION (SO WE REMOVED IT FOR REVIEW)
        "vine_fruit_set_potent_eff",
        "vine_productivity_potent",
        "vine_vigour_balance",
        "vine_disease_psa_resist",
        "vine_preharv_adapt",
        "vine_frost_tolerance",
        "vine_waterlogging_suscept",
    ],

    measures: [
        "vine_tdia",
        "vine_total_bud",
        "vine_bud_per_square",
        "vine_bud_flower",
        "vine_bud_no_flower",
        "vine_flower_per_square",
        "vine_side_flower",
        "vine_misshaped_flower",
        "vine_total_king_flower",
        "vine_triplets",
        "vine_cane_len",
        "vine_fruit_per_square",
        "vine_est_yield",

        "frut_weight",
        "frut_weight_dry",
        "frut_tss",
    ],

    indexes: [
        // TODO add indexes
    ],

    calculations: [
        "tree_age",
        "tree_total_flowers",
        "tree_king_flower_perc",
        "tree_side_flower_perc",
        "tree_mishapped_flower_perc",
    ]
}